import { StateSelector } from '@app/core/store/shared/state';

import { Tag } from '../shared/tag.type';

export class TagSelectors extends StateSelector<Tag> {}
